import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events'; // Ya importamos el evento que necesitamos

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // INICIO DE NUESTRO CÓDIGO
    // Añadimos un listener para los formularios de recomendación
    // Usamos 'this' para que el listener esté solo en este componente
    this.addEventListener('submit', this.#handleRecommendationSubmit);
    // FIN DE NUESTRO CÓDIGO
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // INICIO DE NUESTRO CÓDIGO
    // Limpiamos el listener
    this.removeEventListener('submit', this.#handleRecommendationSubmit);
    // FIN DE NUESTRO CÓDIGO
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  // ======================================================
  // INICIO: NUEVO MÉTODO PARA LAS RECOMENDACIONES
  // ======================================================
  #handleRecommendationSubmit = (event) => {
    // 1. Comprobamos si el formulario que se envía es uno de los nuestros
    if (!event.target.hasAttribute('data-cart-recommendation-form')) {
      return;
    }

    // 2. Prevenimos que la página se recargue
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('button[type="submit"]');

    // 3. (Opcional) Mostramos un estado de carga
    submitButton.disabled = true;

    // 4. Preparamos los datos del formulario para enviarlos
    const formData = new FormData(form);

    // 5. Enviamos los datos a la API de Shopify en segundo plano
    // Usamos 'Theme.routes.cart_add_url' que está disponible globalmente
    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      // 6. ¡Éxito! Avisamos al tema que el carrito cambió
      // Disparamos el mismo evento que el tema ya usa.
      // 'cart-items-component' está escuchando este evento y se actualizará solo.
      document.dispatchEvent(new CartAddEvent(data));
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
      // 7. Reactivamos el botón
      submitButton.disabled = false;
    });
  };
  // ======================================================
  // FIN: NUEVO MÉTODO PARA LAS RECOMENDACIONES
  // ======================================================

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}